const data = {
	"feng":{
		"ch":"中文",
		"en":"English"
	}
}
export default {
	data
}